/* eslint-disable no-nested-ternary */
import { useEffect } from 'react';
import Highcharts from 'highcharts';

const ColumnChart = ({ percent, index }) => {
    const totalPercent = 100;
    const topThresholdPercent = 80;
    const averageThresholdPercent = 50;
    const getColor = () => {
        if (percent > topThresholdPercent) {
            return ['#22992E'];
        }
        return percent > averageThresholdPercent ? ['#FFBF1F'] : ['#C52A1A'];
    };
    useEffect(() => {
        const barChart = new Highcharts.Chart({
            title: {
                text: null,
            },
            chart: {
                renderTo: `bar-one-${index}`,
                type: 'bar',
                height: 40,
                width: 150,
                spacingLeft: 2,
                spacingRight: 2,
                backgroundColor: 'transparent',
            },
            colors: getColor(),
            credits: false,
            tooltip: {
                enabled: false,
            },
            legend: false,
            navigation: {
                buttonOptions: {
                    enabled: false,
                },
            },
            xAxis: {
                visible: false,
            },
            yAxis: {
                visible: false,
                min: 0,
                max: 100,
            },
            series: [
                {
                    data: [totalPercent],
                    grouping: false,
                    animation: false,
                    enableMouseTracking: false,
                    showInLegend: false,
                    borderWidth: 0,
                    pointWidth: 12,
                    color: '#F2F2F2',
                },
                {
                    enableMouseTracking: false,
                    data: [percent],
                    borderWidth: 0,
                    pointWidth: 12,
                    animation: {
                        duration: 250,
                    },
                },
            ],
        });
        return () => {
            barChart.destroy();
        };
    }, [percent]);
    return (
        <div id={`bar-one-${index}`} />
    );
};

export default ColumnChart;
